import { createApp } from 'vue'
import __t from "../../../../helpers/translate";
import vue_helpers from "../../../../helpers/check_null";
import {createBootstrap} from 'bootstrap-vue-next';
import application_table from "./application_table.vue";

window.APP_LIST = createApp({
    name : "APP_LIST",
    id : "APP_LIST",
    components : {
        application_table : application_table,
    }
})
    .mixin(__t)
    .mixin(vue_helpers)
    .use(createBootstrap())
    .use(v_store);

APP_LIST.mount('#sale_applications');